import { createRouter, parseSearchWith, stringifySearchWith } from "@tanstack/react-router"
import { rootRoute } from "./routes/__root"
import { indexRoute } from "@/routes"
import { quizRoute } from "./routes/quiz"
import { checkoutRoute } from "./routes/checkout"
import { upsellRoute } from "./routes/upsell"
import { additionalOffersRoute } from "./routes/additional-offers"
import { signinRoute } from "./routes/signin"
import { createAccountRoute } from "./routes/create-account"
import { activateRoute } from "./routes/activate"
import { successRoute } from "./routes/success"
import { redirectRoute } from "./routes/redirect"
import { privacyRoute } from "./routes/privacy"
import { termsRoute } from "./routes/terms"
import { cookiesRoute } from "./routes/cookies"
import { webappRoute } from "./routes/webapp/layout"
import { webappIndexRoute } from "./routes/webapp"
import { settingsRoute } from "./routes/webapp/settings"
import { readingsRoute } from "./routes/webapp/readings"
import { todayRoute } from "./routes/webapp/today"
import { compatibilityRoute } from "./routes/webapp/compatibility"
import { palmistryRoute } from "./routes/webapp/palmistry"
import { soulmateRoute } from "./routes/webapp/soulmate"
import { auraScanRoute } from "./routes/webapp/aura-scan"
import { advisorInnerRoute } from "./routes/webapp/advisor-inner"
import { reportViewRoute } from "./routes/webapp/report-view"

const routeTree = rootRoute.addChildren([
  indexRoute,
  quizRoute,
  checkoutRoute,
  upsellRoute,
  additionalOffersRoute,
  signinRoute,
  createAccountRoute,
  activateRoute,
  successRoute,
  redirectRoute,
  privacyRoute,
  termsRoute,
  cookiesRoute,
  webappRoute.addChildren([
    webappIndexRoute,
    settingsRoute,
    readingsRoute,
    todayRoute,
    compatibilityRoute,
    palmistryRoute,
    soulmateRoute,
    auraScanRoute,
    advisorInnerRoute,
    reportViewRoute,
  ]),
])

export const router = createRouter({
  routeTree,
  // Keep every search param a raw string. The router's default parser runs each
  // value through `JSON.parse`, which turns Meta's 18-digit ad/campaign ids into
  // numbers — they exceed Number.MAX_SAFE_INTEGER (2^53-1), so the tail rounds
  // (…620774 → …620770) and gets written back on the next navigation, corrupting
  // attribution. No route needs non-string search params.
  parseSearch: parseSearchWith((value) => value),
  stringifySearch: stringifySearchWith(JSON.stringify),
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
